import { ICandidate } from '@/shared/api-client/models/candidate';
import { AxiosInstance } from 'axios';
import _ from 'lodash';
import { QueryStringBuilder } from '../helpers';
import { CandidateMapper } from '../../mappers/candidate-mapper';
import { IPagedList, IPagination } from '../models';
import { IBallot } from '../models/ballot';
import { ICandidateUserData } from '../models/candidate-user-data';
import { ICandidateTransport } from '../models/election/candidate-transport';
import { IEncryptedBallotVote } from '../models/encrypted-ballot-vote';
import { ILegacyBallotVote } from '../models/legacy-ballot-vote';

export class VoteClient {

    constructor(private axiosClient: AxiosInstance) {

    }

    public get apiUrl() {
        return `/vote`;
    }

    public async listAllCandidatures(electionId: string): Promise<ICandidate[]> {

        const requestUrl = new QueryStringBuilder().build(`${this.apiUrl}/${electionId}/allCandidates`);

        const response = await this.axiosClient.get<ICandidateTransport[]>(requestUrl);

        return CandidateMapper.toCandidate(response.data);
    }

    public async listCandidatures(electionId: string, pagination?: IPagination): Promise<IPagedList<ICandidate>> {

        let requestUrl = '';

        const urBuilder = new QueryStringBuilder();

        urBuilder.withPaginationIfNotEmpty(pagination);

        requestUrl = urBuilder.build(`${this.apiUrl}/${electionId}/candidates`);

        const response = await this.axiosClient.get<IPagedList<ICandidateTransport>>(requestUrl);

        const mappedCandidates = CandidateMapper.toCandidate(response.data.items);

        return {
            totalNbrOfItems: response.data.totalNbrOfItems,
            items: mappedCandidates
        };
    }

    public async storeEncryptedVote(electionId: string, ballot: IBallot<IEncryptedBallotVote>): Promise<void> {

        try {
            await this.axiosClient.post(
                `${this.apiUrl}/${electionId}/storeEncryptedVote`,
                ballot,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

        } catch (error: any) {

            if (error.response.data) {

                throw error.response.data;
            }

            throw error.response;
        }
    }

    public async storeNotEncryptedVote(electionId: string, ballot: IBallot<ILegacyBallotVote>) {

        try {

            await this.axiosClient.post(
                `${this.apiUrl}/${electionId}/storeVote`,
                ballot,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

        } catch (error: any) {

            if (error.response.data) {

                throw error.response.data;
            }

            throw error.response;
        }
    }
}
